import Grid from "@mui/material/Grid";
import React from "react";
import Dialog from "../../../../components/dialogs/Dialog";
import DialogContent from "../../../../components/dialogs/DialogContent";
import DialogTitle from "../../../../components/dialogs/DialogTitle";
import {t} from "../../../../store/localization/TranslMessasge";
import {useFindUserGroupByIdQuery} from "./UserGroupQuery";
import {UserGroupsTranslationKey} from "./UserGroupsTranslationKey";
import UserGroupBasicInfoPanel from "./UserGroupBasicInfoPanel";
import UserGroupMemberPanel from "./membership/UserGroupMemberPanel";
import UserGroupPermissionPanel from "./permission/UserGroupPermissionPanel";

interface UserGroupDetailDialogProps {
    opened: boolean;
    onClose: () => void;
    userGroupId: string;
}

export default function UserGroupDetailDialog(props: Readonly<UserGroupDetailDialogProps>) {
    const {opened, onClose, userGroupId} = props;

    const {data: userGroup, refetch} = useFindUserGroupByIdQuery(userGroupId);

    function onUpdated() {
        refetch();
    }

    if (userGroup == null) {
        return null;
    }

    return (
        <Dialog open={opened}
                onClose={onClose}
                maxWidth={"lg"}>
            <DialogTitle id="user-group-detail-dialog-title"
                         title={t(UserGroupsTranslationKey.GROUP_DETAIL)}
                         onDialogClosed={onClose}/>
            <DialogContent>
                <Grid container columnSpacing={3}>
                    <Grid item xs={12} md={6}>
                        <UserGroupBasicInfoPanel userGroup={userGroup} onUpdated={onUpdated}/>
                        <UserGroupPermissionPanel groupId={userGroupId}/>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <UserGroupMemberPanel groupId={userGroupId}/>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}
